import { render, staticRenderFns } from "./CovidBanner.vue?vue&type=template&id=81b1d6a2&scoped=true&"
import script from "./CovidBanner.vue?vue&type=script&lang=js&"
export * from "./CovidBanner.vue?vue&type=script&lang=js&"
import style0 from "./CovidBanner.vue?vue&type=style&index=0&id=81b1d6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b1d6a2",
  null
  
)

export default component.exports